import { createScenario } from '@funtech-int/rival';

const scenario = createScenario(() => {});

export default scenario;
